import SignUpForm from './SignUpForm';
import './style.styl';

export { SignUpForm };
export default SignUpForm;
